export const User = {
  STATUS_ACTIVE_TEXT: "Active",
  STATUS_INACTIVE_TEXT: "InActive",

  STATUS_ACTIVE_VALUE: 1,
  STATUS_INACTIVE_VALUE: 2
};
